import { useState, useEffect } from 'react';
import useScreenSize from '../useScreenSize';

export const useNavigationLayout = () => {
  const [renderNavigationMobileLayout, setRenderNavigationMobileLayout] = useState(false);
  const { isXsScreen, isSmScreen } = useScreenSize();

  const isSmallViewport = isXsScreen || isSmScreen;

  useEffect(() => {
    setRenderNavigationMobileLayout(isSmallViewport);
  },[isSmallViewport]);

  return {
    renderNavigationMobileLayout,
  };
};
